import React, { useEffect, useState } from "react";
import { BiSolidCartAdd } from "react-icons/bi";
import MenuItem from "./MenuItem";
import { useCart } from "../CartContext";
import MenuSection from "./MenuSection";
import { useSearch } from "../SearchContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { _post } from "../services/apiClient";

function SubCatItem(props) {
  const recommendedItem = props.recommendedItem;
  const navigate = useNavigate();
  const {
    searchData,
    handleSubCategoryChange,
    setSearchData,
    filter,
    handleFilterChange,
    isAllSelected,
  } = useSearch();
  const [hovered, setHovered] = useState(false);
  const toggleHover = () => setHovered(!hovered);
  const cart = props.cart;
  const {
    totalPrice,
    itemQuantities,
    setItemQuantities,
    updateQuantity,
    newQuantity,
    updateTotalPrice,
    setTotalPrice,
    resetTotalPrice,
  } = useCart();
  const [button, SetButton] = useState(false);
  const quantity = itemQuantities[recommendedItem._id]?.quantity || 0;

  const handleClick = async (e) => {
    e.preventDefault();
    handleSubCategoryChange(recommendedItem._id);

    try {
      const response = await _post("/products-by-subcategory", {
        subcatId: recommendedItem._id,
      });

      if (response.data && response.data.length > 0) {
        setSearchData(response.data);
        navigate(`/products/${recommendedItem._id}`);
      } else {
        // console.log("No products found for this subcategory.");
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  return (
    <div className="px-2 py-2">
      <a
        href="#"
        onMouseEnter={toggleHover}
        onClick={handleClick}
        onMouseLeave={toggleHover}
        className={`block p-4 text-center bg-white rounded-2xl shadow-lg transition-all duration-300 border-2 border-orange-100 ${
          hovered
            ? "shadow-2xl -translate-y-1 scale-[1.02] border-orange-300"
            : ""
        }`}
      >
        <img
          alt={recommendedItem.name}
          src={`${process.env.REACT_APP_IMAGE_BASE_URL}${recommendedItem.image}`}
          loading="lazy"
          className="w-full h-28 sm:h-32 object-cover rounded-xl mb-3"
        />
        <p className="m-0 text-sm font-bold text-orange-900">
          {recommendedItem.subCat}
        </p>
      </a>
    </div>
  );
}

export default SubCatItem;
